import { render, staticRenderFns } from "./area-list.vue?vue&type=template&id=a4174e5a&scoped=true"
import script from "./area-list.vue?vue&type=script&lang=js"
export * from "./area-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4174e5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4174e5a')) {
      api.createRecord('a4174e5a', component.options)
    } else {
      api.reload('a4174e5a', component.options)
    }
    module.hot.accept("./area-list.vue?vue&type=template&id=a4174e5a&scoped=true", function () {
      api.rerender('a4174e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/system-management/area-management/area-list.vue"
export default component.exports